import React from 'react';
import {Col, Card, Button, Badge } from 'react-bootstrap';

import ReactPayPal from './../Paypal/Paypal.js';
import iconAmazon from './../Common/icon-amazon.svg';

const ProductCard = (props)=>{
	const shopNowHandler = ()=>{
		window.open(props.link, '_blank')
	} 

	const truncLimit = 55;
	const des = props.description;
	const shortDes = des.length > truncLimit ? des.substring(0,55)+'...' : des;

	return(
		<Col xs={props.colxs} sm={props.colsm} md={props.colmd} lg={props.collg} xl={props.colxl} 
			className="card-wrapper"
		>
			<Card>
			  <img 	className="card-img-top"
			  		loading="lazy"
			  		src={props.img_s}
			  		srcSet={`${props.img_s} 768w, ${props.img_m} 576w, ${props.img_s} 375w`}
			  		alt={props.title}
			  		/>
			  <Card.Body>
			    <Card.Title>
			    	{props.title}
			  		<Badge variant="Danger" className="price-tag">${`${props.price}`}</Badge>
			    </Card.Title>
			    <Card.Text>
			      {shortDes}
			    </Card.Text>
			    {
			    	!props.link 
			    	&&	<ReactPayPal 	total={500}
				    					price={props.price}
				    					description={props.description}
				    				/>
				}
				{
					props.link 
					&&	<Button 	variant="primary" 
								    className="checkout-button w-100"
								    onClick={() => shopNowHandler()}
								>
							<img 	src={iconAmazon} 
									alt="Amazon logo" 
									className="button-icon"
								/>
							Buy on Amazon
						</Button>
				}

			  </Card.Body>
			</Card>
		</Col>
	)
}

export default ProductCard;